/* eslint semi:0 */
import { keys, serialize, } from 'utils/object'
import BaseClass from 'application/BaseClass'


function getProp(propName){
  const propSources = [this.options, this.vm, this.DEFAULTS, ]
  const prop = propSources.find(
    (source) => {
      if (source && propName in source) {
        const property = source[propName]
        if (property !== null) {
          return property
        }
      }
      return null
    }
  )
  return prop && prop[propName] || null
}

const VIEW_METHOD_NAME = 'view'

export default class BaseView extends BaseClass {

  constructor(options = {}){
    super(options)
    const propNames = new Set(keys(this.DEFAULTS, options))
    propNames.forEach(this.addPropGetter, this)
    this.merge({
      immutableAttrs: Object.create({
        toString: function serializeAttrs(){
          return `[${ serialize(this, '][') }]`
        },
      }),
    })
  }

  addPropGetter(propName){
    Object.defineProperty(this, propName, {
      enumerable: true,
      configurable: true,
      get: getProp.bind(this, propName),
    })
  }

  [VIEW_METHOD_NAME](ctrl){
    if (this[VIEW_METHOD_NAME] === BaseView.prototype[VIEW_METHOD_NAME]) {
      const message = `The '${ VIEW_METHOD_NAME }' method must be overridden in subclasses!`
      this.error(message, { ctrl, context: this, })
      throw new Error(message)
    }
    this.merge({ ctrl, })
  }

  static make(...opts){
    return this
      .create(Object.assign({}, ...opts))
      [VIEW_METHOD_NAME]()
  }

}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/BaseView.js